export default __webpack_public_path__ + "static/media/sub_nft_01_1.bf688276.gif";